// English pages live under /en (the English home is /en itself); everything else is Chinese.
// The URL is the only source of truth for the language, so crawlers and shared links are stable.
export type Locale = 'zh' | 'en';
export const LOCALES: Locale[] = ['zh', 'en'];
const EN_PREFIX = /^\/en(?=\/|$)/;

export function localeFromPath(pathname: string): Locale {
  return EN_PREFIX.test(pathname) ? 'en' : 'zh';
}

// "/en/pricing" -> "/pricing"; "/en" -> "/"; Chinese paths are returned unchanged.
export function stripLocale(pathname: string): string {
  return pathname.replace(EN_PREFIX, '') || '/';
}

// Prefix a canonical (Chinese) path for the given locale; query and hash are preserved.
export function localizePath(path: string, locale: Locale): string {
  const match = path.match(/^([^?#]*)(.*)$/)!;
  const bare = stripLocale(match[1] || '/');
  if (locale !== 'en') return bare + match[2];
  return (bare === '/' ? '/en' : `/en${bare}`) + match[2];
}
